import { mediaGQLFields } from '../media/index.js';
const BASIC_NETWORK_PUBLIC_INFO_FIELDS = {};
const ALL_NETWORK_PUBLIC_INFO_FIELDS = {
    logo: 'basic',
};
export function networkPublicInfoGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_NETWORK_PUBLIC_INFO_FIELDS;
    if (fields === 'all')
        fields = ALL_NETWORK_PUBLIC_INFO_FIELDS;
    return `
    domain
    domainSubfolder    
    id
    membership
    name
    status
    visibility
    faviconId
    jwtSsoAuthUrls {
      authorizationUrl
      signUpUrl
    }
    favicon {
      ${mediaGQLFields('basic')}
    }
    logoId
    ${fields.logo
        ? `
      logo {
        ${mediaGQLFields(fields.logo)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=networkPublicInfo.fields.js.map